import round from 'lodash/round';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import AddToQueueIcon from '@mui/icons-material/AddToQueue';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import BeenHereIcon from '@mui/icons-material/Beenhere';
import DollarIcon from '@mui/icons-material/Paid';
import DoneIcon from '@mui/icons-material/DoneOutline';
import ForumIcon from '@mui/icons-material/Forum';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import LaptopIcon from '@mui/icons-material/Laptop';
import MapPinIcon from '@mui/icons-material/Room';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PeopleIcon from '@mui/icons-material/People';
import StarIcon from '@mui/icons-material/Star';
import SchoolIcon from '@mui/icons-material/School';
import SpeedIcon from '@mui/icons-material/Speed';
import TranslateIcon from '@mui/icons-material/Translate';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import VerifiedIcon from '@mui/icons-material/Verified';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';

import './EmbeddedProviderCard.scss';
import config from '../../config/config';
import {
  formatProviderName,
  formatProviderLocation,
  getProviderUrl,
  getPublicBookingUrl
} from '../../helpers/providers';
import EmbeddedRating from './EmbeddedRating';
import HighlightIcon from '../providers/HighlightIcon';

const cardStyles = {
  borderRadius: '15px',
  border: '1px solid #e0e0e0',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  pointer: 'cursor',
  margin: '0 auto',
  width: '325px',
};

{/* <Stack direction='row' spacing={2} paddingLeft='2em'>
<img 
  src={p.imgSrc}
  alt={formatProviderName(p)} 
  style={{width: '100px', height: '100px', borderRadius: '10%'}}
/>
<Stack spacing={1}>
  <Typography variant='h2' style={{minWidth: '250px'}}>
    {formatProviderName(p)}
  </Typography>
  <Typography variant='body1' color='text.muted'>{`${p.city}, ${p.state}`}</Typography>
  <EmbeddedRating provider={p} />
</Stack>
<Stack spacing={.5}>
  <a href={`https://app.movement-x.com${getProviderUrl(p)}`} target='_blank' rel='noreferrer'>
    <button
      style={{
        height: '50px',
        padding: '0 1.5em',
        borderRadius: '2em',
        border: 'none',
        backgroundColor: config().colors.primary,
        color: '#fff',
        fontSize: '1rem',
        cursor: 'pointer',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        transition: 'background-color 0.3s ease',
        outline: 'none',
      }}
    >
      Book Now
    </button>
  </a>
  <Typography style={{fontSize: '0.8rem', color: '#666'}} align='center'>
    {p?.rate
      ? `From $${round(p.rate / 2, 0)}`
      : null
    }
  </Typography>
</Stack>
</Stack> */}

const EmbeddedProviderCard = props => {
  const {provider: p, highlights} = props;
  const providerHighlights = (p.highlights || [])
    .map(h => highlights.find(highlight => highlight.id === h))
    .filter(h => !!h && h?.category === 'HIGHLIGHT')
    .filter((h, i) => i <= 3);
  // const isMobile = window.innerWidth < 612;
  const url = `https://app.movement-x.com${getProviderUrl(p)}`;
  const width = '325px';
  return (
    <Box style={{maxWidth: '350px', minWidth: '300px', width}}>
      <a href={url} target='_blank' rel='noreferrer' style={{textDecoration: 'none', color: 'inherit'}}>
        <Box className='EmbeddedProviderCard' style={cardStyles} marginBottom={4}>
          <img
            src={p.imgSrc || config().defaultProviderImage}
            alt={`${formatProviderName(p)} Headshot`}
            style={{
              width,
              aspectRatio: '1/1',
              objectFit: 'cover',
              display: 'block',
              borderRadius: '15px 15px 0 0',
            }}
          />
          <Stack padding={2} gap={1} style={{minHeight: '260px'}}>
            <Typography 
              variant='subtitle1' 
              style={{fontSize: '1.25rem', lineHeight: '1.3rem'}}>{formatProviderName(p)}</Typography>          
            <Typography variant='body1' color='text.muted' fontWeight='medium'>
              <Stack direction='row' spacing={1} alignItems='center'>
                <MapPinIcon color='text.muted' style={{fontSize: '1.25em'}}/>
                {formatProviderLocation(p)}
              </Stack>
            </Typography>
            <Stack direction='row' spacing={2}>
              <EmbeddedRating provider={p} />
              {p?.rate
                ? <Typography color='text.muted' fontWeight='medium'>
                  <Stack direction='row' gap={0.5} alignItems='center'>
                    <DollarIcon style={{fontSize: '1.25em'}} />
                    From ${round(p.rate, 0)}/session
                  </Stack>
                </Typography>
                : null
              }
            </Stack>
            <Box style={{minHeight: '76px'}}>
              {p.specializes_in
                ? <Typography variant='body1' fontWeight='medium'>
                  <span style={{}}>Specializes in</span>{' '}
                  {p.specializes_in}
                </Typography>
                : null
              }
            </Box>
            <Box style={{minHeight: '76px'}}>
              {providerHighlights?.length 
                ? 
                  <Grid container spacing={1} paddingTop={1}>
                    {providerHighlights.map((h, i) => (
                      <Grid item xs={6} md={6}>
                        <Typography key={i} variant='body2' color='text.muted'>
                          <Stack direction={'row'} gap={1} alignItems='center'>
                            <HighlightIcon style={{fontSize: '1.25em'}} highlight={h}/>
                            {h.title}
                          </Stack>
                        </Typography>
                      </Grid>
                    ))}
                  </Grid>
                : null
              }
            </Box>
          </Stack>
          <Grid container justifyContent='center' paddingTop={1}>
            <Grid item xs={6}>
              <Button 
                fullWidth
                href={url} 
                target='_blank' 
                rel='noreferrer'
                color='dark'
                className='EmbeddedProviderCardButton EmbeddedProviderCardButtonDark'
                style={{
                  // border: '1px solid #e0e0e0',
                  borderRadius: '0px 0px 0px 15px',
                  borderTop: `1px solid #e0e0e0`,
                  borderBottom: 'none',
                  fontWeight: '700',
                  '&hover': {backgroundColor: '#21A8A8'},
                  backgroundColor: `linear-gradient(45deg, ${config().colors.dark} 30% !important`,
                  // add a gradient background
                }}
              >
                Learn More
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button 
                fullWidth
                variant='contained'
                className='EmbeddedProviderCardButton EmbeddedProviderCardButtonPrimary'
                href={`https://app.movement-x.com${getPublicBookingUrl(p)}`}
                target='_blank' 
                rel='noreferrer'
                style={{
                  borderRadius: '0px 0px 15px 0px',
                  borderTop: `1px solid ${config().colors.primary}`,
                  fontWeight: '700',
                  backgroundColor: `linear-gradient(45deg, ${config().colors.primary} 50% !important`,
                }}
              >
                Book Now
                <EventAvailableIcon style={{marginLeft: '0.5em'}}/>
              </Button>
            </Grid>
          </Grid>
        </Box>
      </a>
    </Box>
  );
};

export default EmbeddedProviderCard;